<template>
  <div class="content  import_new_wrap" >
    <div style="display: flex" >
      <div class="fl back-color-fff borderR6 left-tree-box" :style="'height:' + tableLeftHeight + 'px;'">
        <el-input size="mini" placeholder="输入关键字搜索" v-model="className" clearable style="width: 80%; margin-top:10px;" @change="getDictCategory(2)">
        </el-input>
        <el-button icon="el-icon-plus" class="add-btn" @click="addTypeData">添加字典分类</el-button>
        
        <el-table
          :data="tagList"
          ref="singleTable"
          highlight-current-row
          :show-header="false"
          @row-click="searchDict"
        >
        <el-table-column prop="className">
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.remarks" class="item" effect="light" :content="scope.row.remarks" placement="left">
                <div  style="padding-left: 20px;"  >{{ scope.row.dictTypeName }}</div>
              </el-tooltip>
              <div v-else style="padding-left: 20px;"  >{{ scope.row.dictTypeName }}</div>
              
            </template>
          </el-table-column>
          <el-table-column label="操作" width="65" align="right" >
            <template slot-scope="scope">
              <!-- v-if="shbtn[scope.$index]" -->
              <div class="btn" >
                
                <i
                  class="el-icon-edit-outline i-edit-sty"
                  @click.stop="updateTypeData(scope.row)"
                ></i>
                <i 
                  class="el-icon-delete i-sty"
                  @click.stop="getDeleteData(3,scope.row.guid)"
                ></i>
              </div>
            </template>
          </el-table-column>
          
        </el-table>
        <el-pagination
          :current-page="page1.pageIndex"
          :page-size="page1.pageSize"
          layout="prev, pager, next"
          small
          :pager-count="5"
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :total="page1.totalRows"
        >
        </el-pagination>
      </div>
  
      <div class="right-content-box" >
        <div class="search-area">
          <p class="select-node">
          {{ dicNameTitle }}（{{tableData.length  }}个）
        </p>
          <el-row :gutter="24">
            <el-col :span="8">
              <div class="search-area-div">字典名称</div>
              <el-input size="mini" v-model="dicName" placeholder="请输入" class="ipt-sty" />
            </el-col>
           
            <el-col :span="6" class="search-btn-box">
              <el-button size="mini" type="info" @click="searchDict()">搜索</el-button>
              <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
            </el-col>
          </el-row>
        </div>

        <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px;'">

          <div class="button-area">
            <el-button  size="mini" type="info" v-if="getBtnPermissionsByName('添加字典')" @click="addData">添加字典</el-button>
            <el-button  size="mini" type="default" v-if="getBtnPermissionsByName('批量导入')" @click="batchImport">批量导入</el-button>
            <!-- <el-button  size="mini" type="default" @click="report" v-loading.fullscreen.lock="fullscreenLoading">批量导出</el-button> -->
            <el-button  size="mini" type="default" v-if="getBtnPermissionsByName('批量删除')" @click="getDeleteData(1,'')">批量删除</el-button>
            
          </div>
          <el-table
            v-loading="loading"
            stripe border
            row-key="guid"
            style="width: 100%"
            tooltip-effect="light"
            :height="tableHeight"
            :data="tableData"
            :tree-props="{ children: 'childList', hasChildren: 'hasChildren' }"
            :expand-row-keys="expandRowKeys"
            @expand-change="expandChange"
            @selection-change="handleSelectionChange"
          >
        <!-- selection -->
        <el-table-column type="selection" width="40" header-align="center" align="center" fixed="left"></el-table-column>
       
        <!-- 字典名称 -->
        <el-table-column prop="dicName" width="160" label="字典名称" header-align="center" align="left" fixed="left" show-overflow-tooltip></el-table-column>
        <!-- 字典描述 -->
        <el-table-column prop="remarks" width="120" label="字典描述" header-align="center" align="left"  show-overflow-tooltip></el-table-column>
        <!-- 字典值 -->
        <el-table-column prop="dicValue" width="120" label="字典值" header-align="center" align="left"  show-overflow-tooltip></el-table-column>
        <!-- 界面排序 -->
        <el-table-column prop="orderNum" label="界面排序" width="80" header-align="center" align="right"></el-table-column>
        <!-- 创建人 -->
        <el-table-column prop="createUserName" width="120" label="创建人" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.createUserName ||'-' }}</template>
        </el-table-column>
        <!-- 创建时间 -->
        <el-table-column prop="createTime" width="140" label="创建时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
        </el-table-column>
        <!-- 更新人 -->
        <el-table-column prop="updateUserName" width="120" label="更新人" header-align="center" align="left"  show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.updateUserName ||'-' }}</template>
        </el-table-column>
        <!-- 更新时间 -->
        <el-table-column prop="createTime" width="140" label="更新时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.updateTime | getDate }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="150" fixed="right">
          <template slot-scope="scope">
            <a class="txt-color" v-if="getBtnPermissionsByName('添加下级')" @click="addNext(scope.row)">添加下级 | </a>
            <a class="txt-color" v-if="getBtnPermissionsByName('编辑')" @click="updateData(scope.row)">编辑 | </a>
            <a class="txt-color" v-if="getBtnPermissionsByName('删除')" @click="getDeleteData(2,scope.row.guid)"> 删除</a>
          </template>
        </el-table-column>
      </el-table>
          <!-- <el-pagination class="pt pb back-color-fff" background @size-change="handleSizeChange"
          @current-change="handleCurrentChange" 
          :page-sizes="[10,20,50,100, 200]"
          :current-page="page.pageIndex"
          :page-size="page.pageSize" 
          layout="total, sizes, prev, pager, next, jumper" 
          :total="page.totalRows">
        </el-pagination> -->
        </div>
      </div>
      
    </div>
    <!-- start of dialog-左侧词典添加分类-新增|编辑 -->
    <el-dialog :title="isAdd ? '新增字典分类' : '编辑字典分类'" :visible.sync="editTypeDialog" width="500px">
      <el-form
        ref="formData"
        label-width="80px" 
        :model="formData"
        :rules="formRules"
      >
        <!-- 分类名称 -->
        <el-form-item label="分类名称" prop="dictTypeName" >
          <el-input size="small" maxlength="15" v-model="formData.dictTypeName"  placeholder="请输入" clearable @input="formData.dictTypeName = formData.dictTypeName.replace(/\s+/g, '')"/>
        </el-form-item>
        <!-- 分类描述 -->
        <el-form-item label="分类编码" prop="code" >
          <el-input size="small" maxlength="15" v-model="formData.code" placeholder="请输入" clearable @input="formData.code = formData.code.replace(/[^\d]/g, '')"/>
        </el-form-item>
        <!-- 界面排序 -->
        <el-form-item  label="界面排序" prop="orderNum" style="margin-bottom:10px;" >
          <el-input size="small" maxlength="30" v-model="formData.orderNum" placeholder="请输入" clearable @input="formData.orderNum = formData.orderNum.replace(/[^\d]/g, '')"/>
        </el-form-item>
        <!-- 用途描述 -->
        <el-form-item  label="用途描述" prop="remarks" style="margin-bottom:10px;" >
          <el-input size="small" maxlength="30" v-model="formData.remarks" placeholder="请输入" clearable />
        </el-form-item>
        <!-- 启用状态 -->
        <!-- <el-form-item  label="启用状态" prop="bizState" style="margin-bottom:10px;text-align: left;" >
          <el-radio-group v-model="formData.bizState">
            <el-radio label="Y">启用</el-radio>
            <el-radio label="S">停用</el-radio>
          </el-radio-group>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" plain @click="editTypeDialog = false">取 消</el-button>
        <el-button size="mini" type="info" @click="submitDictType()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- end of dialog-左侧医药词典添加分类-新增|编辑 -->
    <!-- start of dialog-右侧医药词典添加分类-新增|编辑 -->
    <el-dialog :title="isAdd ? '新增字典' : '编辑字典'" :visible.sync="editDialog" width="500px">
      <el-form
        ref="formData1"
        label-width="80px" 
        :model="formData1"
        :rules="formRules1"
      >
        <!-- 字典分类 -->
        <el-form-item label="字典分类" prop="classGuid" >
          <el-select :disabled="isNext" style="width: 100%;" size="small" filterable v-model="formData1.classGuid" @change="classChange" placeholder="请选择">
            <el-option v-for="item in allTagList" :label="item.dictTypeName" :value="item.guid" :key="item.guid"> </el-option>
          </el-select>
        </el-form-item>
        <!-- 上级字典 -->
        <el-form-item  label="上级字典" prop="parentGuid" >
          <!-- <el-select v-if="!isNext" style="width: 100%;" size="small"  v-model="formData1.parentGuid" placeholder="请选择">
            <el-option v-for="item in classList" :label="item.dicName" :value="item.guid" :key="item.guid"> </el-option>
          </el-select> -->
          <!-- <el-input v-else disabled size="small"  v-model="formData1.parentName" placeholder="请输入" clearable /> -->
          <el-cascader
            v-model="formData1.parentGuid"
            :disabled="isNext"
            style="width: 100%;"
            :props="{
              value: 'guid',
              label: 'dicName',
              children: 'childList',
              checkStrictly: true,
              emitPath: false
            }"
            :options="classList"></el-cascader>
        </el-form-item>
        <!-- 字典名称 -->
        <el-form-item label="字典名称" prop="dicName" >
          <el-input size="small" maxlength="15" v-model="formData1.dicName"  placeholder="请输入" clearable @input="formData1.dicName = formData1.dicName.replace(/\s+/g, '')"/>
        </el-form-item>
        <!-- 字典值 -->
        <el-form-item label="字典值" prop="dicValue" >
          <el-input size="small" maxlength="100" v-model="formData1.dicValue" placeholder="请输入" clearable />
        </el-form-item>
        <!-- 字典描述 -->
        <el-form-item  label="字典描述" prop="remarks" style="margin-bottom:10px;" >
          <el-input size="small" maxlength="30" v-model="formData1.remarks" placeholder="请输入" clearable />
        </el-form-item>
        <!-- 界面排序 -->
        <el-form-item  label="界面排序" prop="orderNum" style="margin-bottom:10px;" >
          <el-input size="small" maxlength="30" v-model="formData1.orderNum" placeholder="请输入" clearable @input="formData1.orderNum = formData1.orderNum.replace(/[^\d]/g, '')"/>
        </el-form-item>
        <!-- 启用状态 -->
        <!-- <el-form-item  label="启用状态" prop="bizState" style="margin-bottom:10px;text-align: left;" >
          <el-radio-group v-model="formData1.bizState">
            <el-radio label="Y">启用</el-radio>
            <el-radio label="S">停用</el-radio>
          </el-radio-group>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" plain @click="editDialog = false">取 消</el-button>
        <el-button size="mini" type="info" @click="submitDict()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- end of dialog-右侧医药词典添加分类-新增|编辑 -->
    
   
    
  </div>
</template>
<script>
import btnPermisson from '../mixins/btnPermisson';
export default {
  mixins:[btnPermisson],
  data() {
    return {
      tableHeight: window.innerHeight - 264,
      contentMainHeight: window.innerHeight - 200,
      tableLeftHeight: window.innerHeight - 102,
      loading: false,
      visible:false,
      dicNameTitle:'',
     
      dicName:'',//字典名称
      dictTypeGuid:'',//左侧字典的分类
      readList:[],//阅读情况的列表
      medicineDictGuid:'',//存储阅读
      guids:[],
      readTitle:'',
      // 右边列表
      // page: {
      //   pageIndex: 1,
      //   pageSize: 50,
      //   totalPage: 0,
      //   totalRows: 0,
      // },
      
      // 字典分类分页
      page1: {
        pageIndex: 1,
        pageSize: 12,
        totalPage: 0,
        totalRows: 0,
      },
      
     
      
      tagList:[ ],//分类列表
      classList:[ ],//上级字典列表
      allTagList:[],
      sh:[],
      className:'',//字典分类搜索
      isEdit:false,
      tenantGuid:null,
     
      formData:{
        guid: '',
        dictTypeName: '', // 分类名称
        code: '', // 分类编码
        remarks: '', // 用途描述
        orderNum: null, // 界面排序
        bizState: 'Y' // 启用状态
      },
      formData1:{
        guid: '',
        className: '', // 字典分类
        classGuid: '', // 字典分类
        parentGuid: '', // 上级字典
        dicName: '', // 字典名称
        dicValue: '', // 字典值
        remarks: '', // 字典描述
        orderNum: null, // 界面排序
        bizState: 'Y' // 启用状态
      },
      
      isAdd : false,
      isNext : false,
      formRules: {
        dictTypeName: [
          { required: true, message: '分类名称必填', trigger: 'blur' },
        ],
        bizState: [
          { required: true, message: '启用状态必填', trigger: 'blur' },
        ]
      },
      formRules1: {
        classGuid: [
          { required: true, message: '字典分类必填', trigger: 'blur' },
        ],
        dicName: [
          { required: true, message: '字典名称必填', trigger: 'blur' },
        ],
        dicValue: [
          { required: true, message: '字典值必填', trigger: 'blur' },
        ],
        bizState: [
          { required: true, message: '启用状态必填', trigger: 'blur' },
        ]
      },
      // formRules1: {
      //   categoryName: [
      //     { required: true, message: '分类名称必填', trigger: 'blur' },
      //   ],
      //   categoryDesc: [
      //     { required: true, message: '分类描述必填', trigger: 'blur' },
      //   ],
      //   // orderNum: [
      //   //   { required: true, message: '界面排序必填', trigger: 'blur' },
      //   // ],
       
      // },
      // 弹窗
      editTypeDialog:false,
      editDialog:false,
      readDialog:false,
      iconVisible:false,
      fullscreenLoading:false,
      tableData:[],
      tableData1:[],
      tabList: [
      { name: '医药词典'},
      
      { name: '医药政策'},
      
    ],
    tabIndex: 0,
    categoryType:1,
    iconList: [],
    activeIcon: 0,
    chooseURL: null,
    fileName:'',
    expandRowKeys:[],
    multipleSelection:[],
    };
  },
  filters:{
    
    timeFilter(val) {
      console.log('va',val);
      
        if (val&&val.length>2&&val[0]==0) {
          let str=val.slice(1)
          
          return str
        } else {
          return val||'-'
        }
      },
  },
  created() {
    //按钮权限
    this.getMenuList();
    this.getDictCategory()
  },
  beforeRouteEnter(to, from, next) {
    if (from.path === '/importPlatDictList') {
      next((vm) => {
        vm.getDictCategory();
      });
    } else {
     
      next((vm) => {
        vm.className=''
        vm.dicName=''
        vm.getDictCategory(2);
        
      });
    }
  },
  mounted() {
    
  },
  watch: {
    iconVisible(val){
        if(!val){
          this.paramValue=''
          this.getIconList()
        }
      }
  },
  methods: {
    /**
     * 添加左侧字典分类
     */
     addTypeData() {
      this.isAdd = true;
      this.editTypeDialog = true;
      this.formData = {
        guid: '',
        dictTypeName: '', // 分类名称
        code: '', // 分类编码
        remarks: '', // 用途描述
        orderNum: null, // 界面排序
        bizState: 'Y' // 启用状态
      }
      let that = this;
      this.$nextTick(() => {
        that.$refs['formData'].clearValidate();
      })
    },
    // 修改左侧字典分类
    updateTypeData(row){
      this.isAdd=false
      this.editTypeDialog=true
      
      this.formData=JSON.parse(JSON.stringify(row))
      
      console.log('gg', this.formData);
      let that = this;
      this.$nextTick(() => {
        that.$refs['formData'].clearValidate();
      })
    },
    /**
     * 添加右侧字典
     */
    addData() {
      this.isAdd = true;
      this.isNext = false;
      this.getDictCategory(1)
      
      this.editDialog = true;
      this.formData1 = {
        guid: '',
        className: '', // 字典分类
        classGuid: this.dictTypeGuid||'', // 字典分类
        parentGuid: '', // 上级字典
        dicName: '', // 字典名称
        dicValue: '', // 字典值
        remarks: '', // 字典描述
        orderNum: null, // 界面排序
        bizState: 'Y' // 启用状态
      }
      this.classChange(true)
    },
    addNext(row) {
      this.isAdd = true;
      this.isNext = true;
      this.getDictCategory(1)
      
      this.editDialog = true;
      this.formData1 = {
        guid: '',
        className: '', // 字典分类
        classGuid: this.dictTypeGuid||'', // 字典分类
        parentGuid: row.guid||'', // 上级字典
        dicName: '', // 字典名称
        dicValue: '', // 字典值
        remarks: '', // 字典描述
        orderNum: null, // 界面排序
        bizState: 'Y' ,// 启用状态
        // parentName:row.dicName
      }
      console.log('...',this.formData1);
      this.classChange(true)
      // if(row){
      //   this.classChange(true)
      //   // this.formData1.classGuid=row.classGuid
      //   // this.formData1.parentGuid=row.guid
      //   this.formData1.parentName=row.dicName

      // }
    },
    // 修改右侧字典
    updateData(row){
      this.isAdd=false
      this.isNext = false;
      this.formData1=JSON.parse(JSON.stringify(row))
      this.getDictCategory(1)
      // 修改的时候要提前获取上级字典的下拉列表
      this.classChange(true)
      console.log('8',row);
      
      this.editDialog=true
      
      console.log('gg', this.formData1);
    },
  
    classChange(flg){
      // 有flg是从编辑进来的
      let that=this
      if(!flg){
        this.formData1.parentGuid=null
      }
      console.log('321',that.formData1);
      
      // 获取上级字典下拉选项
      that.api.get(`/${serverConfig.msConfigureService}/dict/get-tree-by-dictTypeGuid?dictTypeGuid=${that.formData1.classGuid}`).then((res) => {
        
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            that.classList = res.data.data||[];
          
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 批量导入
    batchImport() {
      this.$router.push({
        path: "/importPlatDictList",
        query: { 
          productGuid: localStorage.productGuid,
        },
      });
    },
    // 导出阅读明细
    // report(){
    //   return
    //     let that = this;
    //     that.fullscreenLoading = true;
    //     let req = {
    //         pageIndex: 1,
    //         pageSize: -1,
    //         keywordSearch:that.keywordSearch,
    //         bizState:that.bizState==0?'':that.bizState,
    //         categoryGuid:that.categoryGuid
    //       };
    //     let reqUrl=`/${serverConfig.msProductService}/medicine-policy/export-read-info`
       
    //     that.api.postJson(reqUrl, req).then((res1) => {
    //       console.log('res',res1.data);
    //     if (res1.data.code == 'S0010') {
    //       // that.searchDict()
    //       that.$message.error(res1.data.msg);
    //       that.fullscreenLoading = false;
          
          
    //     } else {
    //       that.api.postJsonD(reqUrl, req).then(res => {
            
    //         let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
    //         console.log('blob',blob);
            
    //         let str='平台字典明细_'
            
    //         let fileName = str + this.$moment(new Date()).format('YYYYMMDD');
    //         let objectUrl = URL.createObjectURL(blob);
    //         const link = document.createElement('a');
    //         link.download = fileName;
    //         link.href = objectUrl;
    //         link.click();
    //         that.fullscreenLoading = false;
    //       });
    //     }
    //   });
    // }, 
   
    emptySearch(){
      
      this.dicName=''
      this.searchDict()
    },
    
    
    //获取平台词典列表
    searchDict(row){
      console.log('点击分类',this.dictTypeGuid);
      
      let that=this
      if(row){// 点击左侧分类
        console.log('rr',row);
          // that.dictType=row.className
          // that.dicNameTitle=row.dicName
          that.dicNameTitle=row.dictTypeName
          that.dictTypeGuid=row.guid
          // that.page.pageIndex=1
      }else{// 点击搜索、清空搜索
        if(!that.dictTypeGuid){
          that.$nextTick(() => {
            that.$refs['singleTable'].setCurrentRow(that.tagList[0]);
          })
        }else{
          let idx=that.tagList.findIndex(item=>{
            return item.guid==that.dictTypeGuid
          })
          that.$nextTick(() => {
            that.$refs['singleTable'].setCurrentRow(that.tagList[idx]);
          })
        }
        
        
      }
      console.log('row',row);
      
        
      that.loading=true
      
      that.api.get(`/${serverConfig.msConfigureService}/dict/get-tree-by-dictTypeGuid?dictTypeGuid=${that.dictTypeGuid}&dicName=${that.dicName}`).then((res) => {
        that.loading=false
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          that.tableData = res.data.data||[];
          if(that.tableData.length>0){
            that.tableData.forEach(i=>{
            
            i.parentGuid=''
              // if(i.childList&&i.childList.length>0){
              //   i.childList.forEach(j=>{
              //     j.classGuid=i.parentGuid
              //   })
              // }
            })
            console.log('99',that.tableData);
            
          }
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 获取左侧字典分类
    getDictCategory(type){
      console.log('2',type);
      if(type==2){
        this.page1= {
          pageIndex: 1,
          pageSize: 12,
          totalPage: 0,
          totalRows: 0,
        }
      }
      
      let that=this
      let req = {
        pageIndex: that.page1.pageIndex,
        pageSize: that.page1.pageSize,
        className:that.className,
      };
      // 打开新增编辑字典弹窗的时候type为1
      if(type==1){
        req.pageSize=-1
      }
      that.loading = true;
      that.api.postJson(`/${serverConfig.msConfigureService}/dict/data/get-class-list`, req).then((res) => {
        that.loading = false;
        console.log('3');
        
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          console.log('4');
          if(type==1){
            that.allTagList = res.data.data.records||[];
          }else{
            that.tagList = res.data.data.records||[];
            that.page1.totalPage = res.data.data.totalPages;
            that.page1.totalRows = res.data.data.totalRows;
            console.log('5');
            if(that.tagList[0]){
              // that.dictTypeGuid= that.tagList[0].guid
              that.dicNameTitle= that.tagList[0].dictTypeName
              that.dictTypeGuid= that.tagList[0].guid
              console.log('8',that.dicNameTitle);
              
              that.searchDict()
            }
          }
          // that.tagList.unshift({categoryName : "全部分类"})
          
          
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 获取上级字典下拉选项
    getSelectList(){
      let that=this
      
      that.loading = true;
      // that.api.get(`/${serverConfig.msConfigureService}/dict/get-tree-by-dictType?dicName=${}&dictType=${}`).then((res) => {
      //   that.loading = false;
      //   if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
      //     that.tagList = res.data.data.records||[];
      //     // that.tagList.unshift({categoryName : "全部分类"})
      //     that.page1.totalPage = res.data.data.totalPages;
      //     that.page1.totalRows = res.data.data.totalRows;
      //     if(that.tagList[0]){
      //       that.dictTypeGuid= that.tagList[0].guid
      //       that.dicNameTitle= that.tagList[0].dicName
      //       that.searchDict()
      //     }
          
      //   } else {
      //     that.$message.error(res.data.msg);
      //   }
      // });
    },
    // 提交字典分类
    submitDictType(){
      let that=this
      let req = {
        ...that.formData,
        // homeCategoryUrl
      };
      that.$refs.formData.validate((valid) => {
        if (valid) {
          this.loading=true
          that.api.postJson(`/${serverConfig.msConfigureService}/dict/save-class`, req).then((res) => {
            that.loading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.getDictCategory()
              this.editTypeDialog = false;
              this.isAdd=false
              
            } else {
              that.$message.error(res.data.msg);
            }
          });
        }else {
          console.log('error submit!!');
          return false;
        }
      });
      
      
      
     
    },
    // 提交字典
    submitDict(){
      let that=this
      let req = {
        ...that.formData1,
        // homeCategoryUrl
      };
      // if(that.isNext)this.$delete( req, 'parentName')
      that.$refs.formData1.validate((valid) => {
        if (valid) {
          this.loading=true
          that.api.postJson(`/${serverConfig.msConfigureService}/dict/save-platform-dict`, req).then((res) => {
            that.loading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              // this.getDictCategory()
              this.searchDict()
              this.editDialog = false;
              this.isAdd=false
              this.isNext=false
            } else {
              that.$message.error(res.data.msg);
            }
          });
        }else {
          console.log('error submit!!');
          return false;
        }
      });
      
      
      
     
    },
    // 删除字典或字典分类
    delData(guid){
      let that=this
      that.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
          that.loading = true;
          let guids=[guid]
          // tenant/data/delete
          that.api.postJson(`/${serverConfig.msConfigureService}/dict/del`,guids).then((res) => {
            that.loading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              that.$message.success('删除成功');
              that.dictTypeGuid=''
              console.log('1');
              
              this.getDictCategory()

            } else {
              that.$message.error(res.data.msg);
            }
          });
        
          
        
      });
    },
    // 批量删除
    getDeleteData(flg, guid) {
      // 1是批量删除，2是右侧列表删除，3是左侧列表删除
      let that = this;
      if(flg == 1 && that.multipleSelection.length == 0){
        return  that.$message.error("请勾选数据！");
      }

      if(flg == 2||flg==3) {
        that.multipleSelection = [];
        that.multipleSelection.push(guid);
      }
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.api.postJson(`/${serverConfig.msConfigureService}/dict/del`, that.multipleSelection)
        .then((res) => {
          if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
            // if(self.expandRowKeys && self.expandRowKeys.length > 0){
            //   self.expandRowKeys.forEach((i,index1)=>{
            //     self.multipleSelection.forEach((j,index2)=>{
            //       if (i === j) {
            //         self.expandRowKeys.splice(index1, 1, "del")
            //       }
            //     })
            //   })
            //   self.expandRowKeys = self.expandRowKeys.filter(item => item !== "del")
            // }
            that.$message.success('删除成功');
            // that.dictTypeGuid=''
            that.multipleSelection = [];
            console.log('1');
            if(flg==3){
              this.getDictCategory()
            }else{
              this.searchDict()
            }
            
            
            // that.$message.success('删除成功');
            // self.getData(true);
          }else {
            that.$message.error(res.data.msg);
          }
        }) 
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 右边列表的多选
    handleSelectionChange(val){
      this.multipleSelection = [];
      
      val.forEach((item)=>{
        this.multipleSelection.push(item.guid)
      })
      console.log('vv',this.multipleSelection);
    },
   
    
   
    handleSizeChange1(val) {
      this.page1.pageSize = val;
      this.getDictCategory()//获取字典分类
    },
    handleCurrentChange1(val) {
      this.page1.pageIndex = val;
      this.getDictCategory()//获取字典分类
    },
    /**
     * 行展开关闭
     */
     expandChange(row, expandedRows){
      if(expandedRows){
        if(this.expandRowKeys && this.expandRowKeys.length > 0){
          let flg = false;
          this.expandRowKeys.forEach(i =>{
            if(row.guid == i){
              flg = true;
            }
          })
          if(!flg){
            this.expandRowKeys.push(row.guid);
          }
        }else{
          this.expandRowKeys.push(row.guid);
        }
        
      }else{
        this.expandRowKeys.forEach((i,index) =>{
          if(i.guid == row.guid){
            this.expandRowKeys.splice(index,1);
          }
        })
      }
      console.log('展开',this.expandRowKeys)
    },
    
    
    
  },
};
</script>
<style lang="less" scoped>
.import_new_wrap{
  padding: 0;
}
.read-title{
  text-align: left;
  margin: 6px 0px -10px 7px;
}
.state-class{
  height: 22px;
  box-sizing: border-box;
  background: #F2FFF5;
  border: 1px solid rgba(220,250,228,1);
  border-radius: 2px;
  font-size: 12px;
  color: #1BA854;
  letter-spacing: 0;
  line-height: 18px;
  padding:4px

  }
.state-class-grey{
  height: 22px;
  box-sizing: border-box;
  background:  #F5F5F5;
  border: 1px solid rgba(217,217,217,1);
  border-radius: 2px;
  font-size: 12px;
  color: #404040;
  letter-spacing: 0;
  line-height: 18px;
  padding:4px
  
  }
.all-classify{
  padding-left: 20px;
  text-align: center;
  width: 50%;
  padding: 12px 0;
}
.color-grey{
  background: #ecf5ff;
}
.left-content {
  width: 20%;
  height: 100%;
  padding: 20px;
  margin-right: 10px;
  background: #fff;
  border-radius: 4px;
}
.right-content {
  flex: 1;
  overflow: hidden;
}
.el-col-5 {
  width: 33%;
  margin-bottom: 15px;
}
.el-col-4 {
  width: 33%;
}
.payment-information {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 30px;
  border: 1px solid #d2d2d3;
  border-radius: 4px;
  padding: 20px;
}
.pay-item {
  display: flex;
  width: 90%;
  margin-top: 10px;
  margin-bottom: 10px;
}
.pay-name {
  width: 100px;
  line-height: 32px;
  text-align: right;
  flex-shrink: 0;
  margin-right: 10px;
}
.pay-left {
  width: 100%;
}
.pay-right {
  width: 10%;
  /* flex-shrink: 0; */
}
.i-edit-sty {
  font-size: 20px;
  margin-right: 8px;
}
.i-sty {
  font-size: 20px;
}
.btn {
  display: none;
}
.btn i {
  cursor: pointer;
}
.el-table__body tr:hover .btn {
  display: block;
}
/deep/.el-pagination {
  overflow-x: auto;
}
/deep/.el-tabs__header {
  margin: 0;
}
/deep/ .el-tabs--card > .el-tabs__header .el-tabs__nav {
  // border: 0 none;
}
/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  // border: 0 none;
}
/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item {
  // border: 0 none;
}
/deep/ .el-tabs__nav-next {
  font-size: 20px;
}
/deep/.el-tabs__nav-prev {
  font-size: 20px;
}
/deep/.el-tabs__new-tab {
  margin-right: 16px;
}
.top {
  background: #fff;
  margin-bottom: 16px;
}
 .el-table /deep/ .el-input__inner {
 height: 30px;
 line-height: 40px;
}

.el-range-editor.el-input__inner {
 padding: 0px;
}

/deep/ .el-checkbox__label {
 display: none;
}

.attach-sty {
 width: 170px;
 float: left;
 margin-top: 15px;
 text-align: center;
}

.checkbox-img-sty {
 border: 1px solid #dcdfe6;
 width: 16px;
 height: 16px;
 border-radius: 2px;
 cursor: pointer;
}

/deep/ .el-step__icon.is-text {
 border-radius: 50%;
 border-color: #4fa1a4;
 border-color: inherit;
}

/deep/ .el-step__icon-inner {
 color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
 color: #4fa1a4;
}

// .content {
//   background: #fff;
//   font-size: 18px;
// }

.title {
 text-align: left;
 font-size: 16px;
 font-weight: 600;
 display: flex;
 align-items: center;
 margin-bottom: 10px;
}

.title span {
 width: 6px;
 height: 14px;
 background: #4fa1a4;
 display: inline-block;
 margin-right: 10px;
}

.base {
 background: #fff;
 padding: 10px 0;
}

.content h1 {
 margin: 4px 0px;
}

.base-content {
 display: flex;
 font-size: 15px;
 padding: 7px 0;
}

.base-content .base-info {
 display: flex;
 align-items: center;
 padding: 0 40px;
}

.base-content .base-info .base-title {
 word-break: keep-all;
}

.button-area {
 display: flex;
 justify-content: flex-start;
 padding: 0px 20px 0px 10px;
 margin-top: 0;
}

/deep/.el-checkbox__label {
 display: block;
}

.checkbox-show {
 display: flex;
 margin-bottom: 10px;
}
.field-show {
 display: flex;
 align-items: center;
 height: 40px;
 padding-left: 10px;
}

.product {
 display: flex;
 align-items: center;
}

.product-img {
 width: 60px;
 height: 40px;
 margin-right: 15px;
}

.product-text {
 width: 130px;
 overflow: hidden;
 text-overflow: ellipsis;
 white-space: nowrap;
}

 .el-col-5 {
   width: 33%;
 }
 
 .ipt-sty {
   width: 69% !important;
 }
 .add-btn{
   width: 80%;
   height:28px;
   line-height: 28px;
   margin: 8px 0px;
   padding: 0;
 }
 .flex{
   width: 80%;
   margin: auto;
   display: flex;
   justify-content: space-between;
 }
 .flex1{
   display: flex;
   flex-direction: column;
   justify-content: space-between;
 }
 
 .checkTag{
   background-color:rgb(242, 242, 242) ;
 }
 .btn {
 display: none;
}
.btn a {
 cursor: pointer;
}
 .el-table__body tr:hover .btn {
 display: block;
}

 /deep/.el-tree-node__label {
   width: 80%;
   white-space: normal;
   overflow: hidden;
   text-align: left;
 }
 
 .el-tree-node__content {
   height: auto;
 }
 
 .radio-ora {
   margin-right: 12px;
 }
 
 .staff-type {
   display: inline-block;
   width: 72px;
   height: 28px;
   line-height: 28px;
   color: #4FA1A4;
   background: rgba(234, 248, 248, 0.39);
   border-radius: 2px;
 }
 
 .staff-type-biz {
   display: inline-block;
   width: 52px;
   height: 28px;
   line-height: 28px;
   color: #4FA1A4;
   background: rgba(234, 248, 248, 0.39);
   border-radius: 2px;
 }
 
 .staff-wrap {
   color: #D8814B;
   background: rgba(255, 238, 224, 0.39);
 }
 
 .biz-state {
   display: inline-block;
   width: 48px;
   height: 21px;
   line-height: 21px;
   background: rgba(239, 239, 239, 0.38);
   border-radius: 11px;
   margin-left: 5px;
 }
 
 .select-node {
   margin: 0 0 17px 0;
   text-align: left;
   font-size: 18px;
   color: #323233;
 }
 
 .custom-tree-node {
   display: inline-flex;
   overflow: hidden;
 }
 
 .content-main-box {
  
   overflow-y: visible;
 }
 
 .el-col-6{
  display: flex;
  /* margin-bottom: 10px; */
}
 .el-col-8{
  display: flex;
  /* margin-bottom: 10px; */
}
.search-area-div {
  width: 64px;
  /* text-align: right; */
}
.ipt-sty{
  flex: 1; 
}
 /* .el-pagination {
   width: calc(100% - 260px - 231px);
 } */
 .icon-dialog {
  display: flex;
  overflow: hidden;
}

.icon-dialog .icon-left {
  width: 180px;
  text-align: left;
  border-right: 1px solid #cccc;
}

.icon-left .item {
  height: 40px;
  line-height: 40px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  padding: 0 20px;
}

.icon-dialog .icon-right {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  height: auto;
  padding-left: 10px;
}

.icon-right .pic {
  width: 100px;
  height: 130px;
  margin-right: 10px;
  margin-bottom: 10px;
}

.icon-right .pic .img {
  width: 100px;
  height: 100px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.06);
}

.icon-right .pic .img:hover {
  border: 1px solid #4fa1a4;
  border-radius: 4px;
}

.img-wrap {
  position: relative;
}

.img-wrap .border-img {
  position: absolute;
  width: 100px;
  height: 100px;
  left: 0;
  top: 0;
}

.img-wrap .name {
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.file-img {
  width: 100%;
  height: 100%;
}

.icon-add {
  float: left;
  margin-left: 10px;
  width: 150px;
  height: 150px;
  border: 1px dotted #ccc;
  text-align: center;
  line-height: 150px;
}

.img-close {
  position: relative;
  float: left;
  width: 150px;
  height: 150px;
  margin-left: 20px;
}

.close {
  position: absolute;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
}
/deep/ .el-table-column--selection .cell{
  padding-right:10px
}

</style>
<style>

.icon-dialog-wrap .el-dialog__body {
  padding: 0;
  padding-top: 10px;
}
#template-config .el-dialog {
    /* height: 80vh; */
    overflow: auto;
}
#template-config .el-form-item__content{
  margin-left:15px !important;
  display: flex;
}
#template-config .el-form-item{
  align-items:flex-start;
}
#template-config .calc-type .el-form-item__label{
  line-height:15px;
}
.el-table .cell{
  white-space: nowrap;
}
  .el-input__inner{
    padding: 0 8px;
  }
  .detail-class .el-table__row{
    height: 12px;
    line-height: 12px;
  }
  .el-collapse-item__header {
    padding-left: 15px;
  }
  
  .el-upload--picture-card {
    float: left;
    margin-right: 10px;
  }
  
  .circle-closesty {
    position: relative;
    top: -35px;
    margin-left: 112px;
    font-size: 20px;
    cursor: pointer;
  }
  
  .v-modal {
    z-index: 100 !important;
  }
  
  .select-box {
    overflow: hidden;
    margin: 0 0px 10px 30px;
  }
  
  .box-left {
    width: 40%;
    height: 350px;
    padding: 0 20px 20px 20px;
    border: 1px solid #bbb;
    box-sizing: border-box;
    overflow-y: auto;
  }
  
  .box-right {
    width: 57%;
    height: 350px;
    padding: 0 10px 20px 20px;
    border: 1px solid #bbb;
    box-sizing: border-box;
  }
  
  .field-radio {
    display: flex;
    align-items: center;
  }
  
  .field-radio .el-form-item__content {
    margin-left: 0 !important;
  }
  .el-form-item {
    margin-bottom: 18px;
  }
  
  .other-config {
    display: flex;
    font-size: 14px;
    padding-left: 50px;
    /* padding-top: 30px; */
  }
  
  .other-content {
    flex: 1;
  }
  
  .other-content-list {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .other-title {
    padding-right: 10px;
  }
  
  /* 报货配置 */
  .bh-config-box {
    display: flex;
    height: 40px;
    align-items: center;
    font-size: 14px;
    padding-left: 50px;
    padding-top: 10px;
  }
  
  .bh-config-title {
    margin-right: 10px;
  }
  
  /* 库存信息采集 */
  .kc-label {
    font-size: 12px;
    color: #86909c;
  }
  
  .kc-label span {
    color: #4fa1a4;
    cursor: pointer;
  }
  
  .kc-box {
    padding: 16px;
    box-sizing: border-box;
  }
  
  .kc-box .el-tabs--border-card > .el-tabs__header .el-tabs__item {
    color: #323232;
  }
  
  .kc-box .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    color: #323232;
  }
  .el-tabs__item.is-active{
    color: #4fa1a4;
  }
  .kc-box .el-tabs__item {
    border-right: 1px solid #dcdfe6 !important;
  }
  
  .kc-tab-box {
    height: 340px;
    padding: 0 0 40px;
    font-size: 14px;
    overflow-y: auto;
    box-sizing: border-box;
  }
  
  .kc-tab-list {
    padding: 0 0 40px 0;
    box-sizing: border-box;
    border-bottom: 1px solid #dcdcdc;
  }
  
  .kc-tab-list:last-child {
    padding-bottom: 0;
    border-bottom: none;
  }
  
  .kc-tab-label {
    display: flex;
    margin-top: 30px;
  }
  
  .label-left-name img {
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }
  
  .tab-label-left {
    width: 350px;
    display: flex;
    margin-right: 20px;
  }
  
  .label-left-name {
    width: 100px;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    flex-shrink: 0;
  }
  
  .tab-label-right {
    display: flex;
    align-items: center;
    color: #c8c8c8;
  }
  
  .tab-label-add {
    color: #4fa1a4;
    cursor: pointer;
    margin-right: 10px;
  }
  
  .tab-label-del {
    color: #d0021b;
    cursor: pointer;
    margin: 0 10px;
  }
  
  .kc-tab-rules {
    display: flex;
    margin-top: 16px;
  }
  
  .kc-rules-center {
    display: flex;
    align-items: center;
  }
  
  .rules-center-input span {
    margin: 0 8px;
  }
  
  .kc-no-label {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .kc-no-label img {
    width: 213px;
    margin-right: 35px;
  }
  
  .no-label-text {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  
  .no-label-text h3 {
    font-size: 18px;
    color: #7f828f;
    text-align: left;
    font-weight: 500;
    margin: 0;
  }
  
  .no-label-text p {
    font-size: 14px;
    color: #7f828f;
    line-height: 20px;
    margin: 6px 0 13px;
    text-align: left;
  }
  
  .no-label-btn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    border-radius: 2px;
    text-align: center;
    color: #4fa1a4;
    cursor: pointer;
    border: 1px solid #4fa1a4;
  }
  
  .dy-table {
    width: 800px;
    margin-left: 10px;
  }
  
  .dy-table .dy-table-title {
    display: flex;
    height: 60px;
    line-height: 60px;
    background: #f2f2f2;
    border-bottom: 1px solid #ddd;
  }
  
  .dy-table .dy-table-title div {
    width: 200px;
  }
  
  .dy-table .dy-table-item {
    display: flex;
    height: 50px;
    align-items: center;
    border-bottom: 1px solid #ddd;
  }
  
  .dy-table-item-label {
    width: 200px;
    flex-shrink: 0;
    text-align: center;
  }
  
  .dy-table .dy-radio-box {
    width: 200px !important;
    text-align: center;
  }
  
  .dy-config-wrap {
    display: flex;
    font-size: 14px;
    margin: 30px 0;
    padding-left: 50px;
  }
  
  .dy-config-title {
    flex-shrink: 0;
    margin-top: 20px;
  }
  
  .product-select-all {
    margin-bottom: 20px;
  }
  .title-content {
    margin-top: 10px;
    margin-bottom: 10px;
    display: flex;
    width: 100%;
  }
  .title-item {
    vertical-align: middle;
    text-align: center;
    padding-right: 10px;
  }
  .left-text {
    text-align: left;
  }
  .w200 {
    width: 30%;
  }
  .w160 {
    width: 160px;
  }
  .w240 {
    width: 200px;
  }
  .w100 {
    width: 100px;
  }
  .configure-fields {
    width: 760px !important;
  }
  .configure-fields .el-dialog__body {
    overflow-y: auto;
    max-height: 600px;
  }
  .el-dialog__footer {
    border-top: 1px solid #d9d9d9;
  }
  .el-dialog__header {
    border-bottom: 1px solid #d9d9d9;
  }
  /* 选项内容样式 */
  .select-content-box {
    width: 92%;
    margin: 0 0px 10px 30px;
  }
  .select-content {
    width: 100%;
    /* padding:0 10px; */
    background: #fafafa;
    border: 1px solid #e5e5e5;
  }
  .el-form-item__label {
    color: #666;
  }
  .select-content .el-form-item__label {
    width: 90px !important;
  }
  .select-content .el-form-item__content {
    margin-left: 90px !important;
  }
  .config-item .el-form-item__content {
    margin-left: 0px !important;
  }
  /*  */
  .max-value {
    position: relative;
    height: 40px;
  }
  .max-value .el-input-number--mini {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 104px;
  }
</style>

